import React, { useState } from 'react';
import { BsFileEarmarkMedicalFill } from 'react-icons/bs';
import { Box, Divider, Flex, HStack, Icon, Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../../../../../styles/theme/foundation/colors';

const ResourceDocumentButton = ({
  links = [],
  handleDocClick = () => {}
}) => {
  const [showResources, setShowResources] = useState(false);
  return (
    <Box>
      <HStack
        cursor="pointer"
        w="250px"
        onClick={() => setShowResources(!showResources)}
      >
        <Text
          _hover={{
            textDecoration: 'underline',
            textDecorationColor: 'rgba(214, 48, 228, 0.5)',
            textUnderlineOffset: '4px'
          }}
          bgClip="text"
          bgGradient={colors.gradient.aiPrimary}
          textAlign="left"
          textStyle="bodyMd600"
        >
          {`${showResources ? 'Hide' : 'View'} Resource Document`}
        </Text>
        <Icon viewBox="0 0 24 24">
          <defs>
            <linearGradient id="arrowGradient" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0%" stopColor="#008CFF" />
              <stop offset="28%" stopColor="#5D56FA" />
              <stop offset="53%" stopColor="#7137F1" />
              <stop offset="80%" stopColor="#A334EC" />
              <stop offset="100%" stopColor="#D630E4" />
            </linearGradient>
          </defs>
          <path
            d="M5 12h14M12 5l7 7-7 7"
            fill="none"
            stroke="url(#arrowGradient)"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </Icon>
      </HStack>

      {showResources && (
        <Box m={4} minH="100px" minW="200px">
          <HStack mb={2}>
            <Icon as={BsFileEarmarkMedicalFill} boxSize={4} color="primaryScale.600" />
            <Text>Files Used for Answer</Text>
          </HStack>

          <Divider mb={2} />

          {links?.map(link => {
            const { linkable, linkableType, linkableId } = link;
            if (linkableType === 'insurance_document') {
              return (
                <Flex
                  alignItems="center"
                  justifyContent="space-between"
                  key={linkableId}
                  my={2}
                  width="200px"
                >
                  <Tooltip
                    aria-label={`Document Name: ${linkable.displayName}`}
                    label={linkable.displayName}
                  >
                    <Text
                      _hover={{ color: 'primaryScale.600', cursor: 'pointer' }}
                      color="greyScale.800"
                      noOfLines={1}
                      pt={0}
                      textStyle="button"
                      onClick={() => handleDocClick(linkableId)}
                    >
                      {linkable.displayName}
                    </Text>
                  </Tooltip>
                </Flex>
              );
            }

            return <div />;
          })}
        </Box>
      )}
    </Box>
  );
};

ResourceDocumentButton.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    linkableType: PropTypes.string,
    linkableId: PropTypes.number,
    linkable: PropTypes.shape({ displayName: PropTypes.string })
  })),
  handleDocClick: PropTypes.func
};

export default ResourceDocumentButton;
